import { PERIOD_SCALE_ENUM } from '~/modules/resourcing/common/enums';

export default {
  [PERIOD_SCALE_ENUM.DAYS]: { days: 1 },
  [PERIOD_SCALE_ENUM.WEEKS]: { weeks: 1 },
  [PERIOD_SCALE_ENUM.MONTHS]: { months: 1 },
  [PERIOD_SCALE_ENUM.QUARTERS]: { quarters: 1 },
  [PERIOD_SCALE_ENUM.YEARS]: { years: 1 }
};
